import { useRightColumnContext } from 'Context/RightColumnContext';
import React from 'react';
import ScenarioQuestionDrawer
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker/ScenarioQuestionDrawer';

const ScenarioQuestionPicker = () => {
  const {
    showRightColumnCollection, rightColumnCollectionLoading,
  } = useRightColumnContext();

  if (!showRightColumnCollection || rightColumnCollectionLoading) {
    return null;
  }

  return <ScenarioQuestionDrawer />;
};

export default ScenarioQuestionPicker;
